import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { HEADER_HEIGHT, SIDEBAR_MAX_WIDTH } from '../../utils/consts';

export const LogoWrapperS = styled.div`
  color: white;
  height: ${HEADER_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);

  div {
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      display: none;
      line-height: 1.2;
    }
  }
`;

export const NavS = styled.ul`
  margin: 20px 0 0;
  padding: 0;
`;

export const NavItemS = styled.li<{ active?: boolean; hover: boolean }>`
  padding: 7px 20px;
  list-style: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 300;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;

  i {
    font-size: 23px;
    width: 20px;
  }

  svg {
    font-size: 23px;
    width: 20px;
  }

  span {
    white-space: normal;
    font-size: 14px;
    text-overflow: ellipsis;
    flex: 1;
    overflow: hidden;
    padding-left: 25px;
    display: none;
  }

  a {
    word-break: break-word;
    font-size: 14px;
    list-style: none;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.45);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  }

  & {
    fill: rgba(255, 255, 255, 0.45);
  }

  ${({ hover }) =>
    hover
      ? `
    a:hover {
      color: #fff;
    }
  
    &:hover {
      color: #fff;
      fill: #fff;
    }
  
    &:active {
      background: rgba(0, 0, 0, 0.4);
    }
`
      : 'cursor: default;'}

  ${({ active }) =>
    active
      ? `
      color: #fff;
      background: rgba(0, 0, 0, 0.4);
      a {
        color: #fff;
      }
  `
      : ''}
`;

export const RoutPageS = styled(CardS)`
  width: 400px;
  height: calc(100% - 20px);
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
`;

export const WrapperS = styled.aside`
  flex: 0 0 ${SIDEBAR_MAX_WIDTH};
  max-width: 60px;
  min-width: 60px;
  background: rgb(45, 52, 70);
  position: relative;
  height: 100vh;
  overflow: auto;
  transition: 0.2s;
  overflow: auto;
  padding-bottom: 20px;

  &:hover {
    min-width: 240px;
    max-width: 240px;

    &:nth-child(1) {
      span {
        display: block;
      }
    }

    ul {
      display: block !important;
    }

    ${NavItemS} {
      span {
        display: block;
      }
    }

    ${LogoWrapperS} {
      svg {
        width: auto;
      }
    }
  }
`;
